export type AppEnv = 'development' | 'production' | 'staging' | 'test';

const raw = (import.meta as any).env;
export const APP_ENV: AppEnv = (raw?.VITE_APP_ENV || (import.meta.env.DEV ? 'development' : 'production')) as AppEnv;

// Domain and email configuration
export const DOMAIN_CONFIG = {
  // Main domain for the app
  MAIN_DOMAIN: raw?.VITE_MAIN_DOMAIN || 'trynura.app',
  // App subdomain for authenticated users
  APP_SUBDOMAIN: raw?.VITE_APP_SUBDOMAIN || 'beta.trynura.app',
  // Email domain for all system emails
  EMAIL_DOMAIN: raw?.VITE_EMAIL_DOMAIN || 'trynura.app',
  // System email addresses
  NO_REPLY_EMAIL: raw?.VITE_NO_REPLY_EMAIL || 'no-reply@trynura.app',
  HELLO_EMAIL: raw?.VITE_HELLO_EMAIL || 'hello@trynura.app',
  SUPPORT_EMAIL: raw?.VITE_SUPPORT_EMAIL || 'support@trynura.app',
  // Test/demo email addresses
  TEST_EMAIL: raw?.VITE_TEST_EMAIL || 'test@trynura.app',
  DEMO_EMAIL: raw?.VITE_DEMO_EMAIL || 'demo@trynura.app',
} as const;

export const FLAGS = {
  // UI toggles
  showVoiceInspector: APP_ENV !== 'production',
  showDemoRibbons: APP_ENV !== 'production',
  // product experiments
  enablePMFTile: true,
  // perf/logging
  enableVerboseLogs: APP_ENV === 'development',

  // Recipe discovery upgrades (client-side feature gates)
  // Keep these behind config rather than hard-coding env checks in pages.
  // Flipped ON for now; still backed by env if you want to disable explicitly.
  enableFullInsight: raw?.VITE_FEATURE_FULL_INSIGHT
    ? Boolean(raw?.VITE_FEATURE_FULL_INSIGHT === '1' || raw?.VITE_FEATURE_FULL_INSIGHT === 'true')
    : true,
  useV2Swiper: raw?.VITE_USE_V2_SWIPER
    ? Boolean(raw?.VITE_USE_V2_SWIPER === '1' || raw?.VITE_USE_V2_SWIPER === 'true')
    : true,
  useV2PagedDiscover: raw?.VITE_V2_PAGED_DISCOVER
    ? Boolean(raw?.VITE_V2_PAGED_DISCOVER === '1' || raw?.VITE_V2_PAGED_DISCOVER === 'true')
    : false,
} as const;
